import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
// import useCommon from "@/hooks/common.ts";
import {register_device} from "@/utils/firebase_init.ts";

const Notifications = () => {
    const { i18n } = useTranslation();
    const effectRan = useRef<boolean>(false);

    // const common = useCommon()


    useEffect(() => {

        if(!effectRan.current) {
            register_device(i18n.language, "")
            // common.firebase_init(i18n.language)
        }


        return () => {
            effectRan.current = true
        }

    }, []);


    return <></>;
};

export default Notifications;
